<template>
  <b-form-group class="text-area" :label="label" :label-for="'textarea-' + uuid" v-no-capture>
    <textarea-autosize
      :id="'textarea-' + uuid"
      :placeholder="placeholder"
      @keyup.native="$event => $emit('input', $event.target.value)"
      :rows="rows"
      :value="value"
      :min-height="50"
      :max-height="maxHeight"
      class="text-area-field form-control"
      :class="{
        [textareaClass]: textareaClass,
        'error-border': !!errored,
        'no-border': noBorder !== false,
        'document-bg': documentBg !== false,
        'bottom-border': bottomBorder !== false
      }"
      :autosize="autosize"
      v-autofocus="autoFocus !== false"
    />
    <div class="field-error-message mt-1" v-if="hasErrorContent">
      <div v-if="errorMessage">
        {{ errorMessage }}
      </div>
      <div v-else>
        <slot name="error"></slot>
      </div>
    </div>
  </b-form-group>
</template>

<script>
import componentIdMixin from '@/mixins/ComponentIdMixin'
import { BFormGroup } from 'bootstrap-vue'
import TextareaAutosize from 'vue-textarea-autosize/src/components/TextareaAutosize'

/**
 * This is a component that provides textarea
 *
 * This supports `v-model`
 */
export default {
  name: 'TextArea',
  components: {
    TextareaAutosize,
    BFormGroup
  },
  mixins: [componentIdMixin],
  props: {
    placeholder: String,
    label: String,
    value: [String, Number],
    autosize: { default: true, type: Boolean },
    rows: { default: 4, type: Number },
    /**
     *  after which textarea should stop expanding
     */
    maxHeight: { default: 350, type: Number },
    /**
     * class you want to add to textarea element
     */
    textareaClass: { default: '', type: String },
    /**
     * removes border around textarea and gives it white background
     */
    noBorder: { default: false, type: Boolean },
    /**
     * use document color as background
     */
    documentBg: { default: false, type: Boolean },
    bottomBorder: { default: false, type: Boolean },
    autoFocus: { default: false, type: Boolean },
    errored: Boolean,
    errorMessage: String
  },
  computed: {
    hasErrorContent() {
      return this.errorMessage || this.$slots.error
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/base';
@import '~@/styles/errors';
@import '~@/styles/_styleConfigurations.scss';

.text-area {
  position: relative;
}
/deep/ textarea {
  @include scrollbarWidth($scrollSecondary);
}

.field-error-message {
  padding-left: 12px;
}
.text-area-field {
  padding: 12px;
  border-radius: 14px;

  &::placeholder {
    color: #c4c4c4;
  }

  background: #f9f9f9;
  border: 1px solid $borderTertiary;
  resize: none;

  &.no-border {
    border: none;
    background: #fff;
  }

  &.document-bg {
    background: $documentColor;
  }

  &.bottom-border {
    border: none;
    border-bottom: 1px solid #e5e5e5;
    background-color: white;
    border-radius: 0 !important;
    padding: 0 !important;

    &:focus {
      box-shadow: none;
    }
  }
}
.text-area /deep/ label {
  padding-left: 12px;
}
</style>
